export default {
  SET_EQUIP_LIST(state, value) {
    state.equipList = value;
  },
  SET_TRANSPORT_LIST(state, value) {
    state.transportPlans = value;
  },
  SET_BOOKING_LIST(state, value) {
    state.bookingPlans = value;
  },
  SET_JOB_LIST_BOARD(state, value) {
    state.jobListBoard = value;
  },
  SET_TECHNIAN_LIST(state, value) {
    state.technianList = value;
  },
  SET_DRIVER_LIST(state, value) {
    state.driverList = value;
  },
  SET_HOME(state, value) {
    state.home = value;
  },
  SET_OPEN_REQUEST(state, value) {
    state.openRequest = value;
  },
  SET_CLOSE_REQUEST(state, value) {
    state.closeRequest = value;
  },
  SET_CLOSE_CALL(state, value) {
    state.closeCall = value;
  },
  SET_OPEN_CALL(state, value) {
    state.openCall = value;
  },
  SET_TODAY_JOBS(state, value) {
    state.todayJobs = value;
  },
  SET_UPCOMING_JOBS(state, value) {
    state.upcomJobs = value;
  },
  SET_IS_DONE(state, value) {
    state.isDone = value;
  },
  SET_HDCASE(state, value) {
    state.hdcase = value;
  },
  SET_EQUIPS(state, value) {
    state.equips = value;
  },
  SET_EQUIP_HEADER(state, value) {
    state.equipHeader = value;
  },
  SET_EQUIP_DETAIL(state, value) {
    state.equipDetail = value;
  },
  SET_JOBS_LIST(state, value) {
    state.jobsList = value;
  },
  SET_INVOICE_HEADER(state, value) {
    state.invoiceHeader = value;
  },
  SET_INVOICE_DTL(state, value) {
    state.invoiceDtl = value;
  },
  SET_CONTRACT_HEAD(state, value) {
    state.contractHead = value;
  },
  SET_CONTRACT_DTL(state, value) {
    state.contractDtl = value;
  },
  SET_CONTRACT_RENEWAL(state, value) {
    state.contractRenewal = value;
  },
  SET_QUOTE_HEAD(state, value) {
    state.quoteHead = value;
  },
  SET_QUOTE_DTL(state, value) {
    state.quoteDtl = value;
  },
  SET_ORDER_HEAD(state, value) {
    state.orderHead = value;
  },
  SET_ORDER_DTL(state, value) {
    state.orderDtl = value;
  },
  SET_SHIP_HEAD(state, value) {
    state.shipHead = value;
  },
  SET_SHIP_DTL(state, value) {
    state.shipDtl = value;
  },
  SET_RMA_HEAD(state, value) {
    state.rmaHead = value;
  },
  SET_RMA_DTL(state, value) {
    state.rmaDtl = value;
  },
  SET_PROJECT_JOBS(state, value) {
    state.projectJobs = value;
  },
  SET_PROJECT_JOB_DTLS(state, value) {
    state.projectJobsDtls = value;
  },
  SET_INVENTORY(state, value) {
    state.inventory = value;
  },
  SET_MEMO(state, value) {
    state.memo = value;
  },
};
